import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerFilter, IVolunteersFilterRequest } from './models';

export const useExportVolunteersMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			filter = {},
			excludeActivityIds,
			impersonationContext,
		}: {
			filter?: IVolunteerFilter;
			excludeActivityIds?: string[];
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'volunteering/export' }),
				'POST',
				{ filter, excludeActivityIds } satisfies IVolunteersFilterRequest
			),
		onError,
		onSuccess,
	});
};
